import { RunConfigService } from '@nuskin/ns-util';
import { axios } from '@nuskin/axios-util';

const staticAxios = axios.create();

export default {
    methods: {
    /**
     * Load static resources from the /static/address-form-assets s3 bucket
     * @typedef {Object} ResourceDescriptor
     * @property {String} key
     * @property {String} path
     * @property {String} contentType
     * @property {String} defaultData
     *
     * @param {ResourceDescriptor[]} resources the resource paths to load from s3
     * @return {Object} contains results keyed by the resource.key
     */
        async loadStaticResources(resources) {
            const runConfig = RunConfigService.getRunConfig();
            const results = {};
            for (const resource of resources) {
                const config = {
                    method: 'GET',
                    url: `${
                        runConfig.fbBaseUrl ? runConfig.baseUrl : ''
                    }/static/address-form-assets/${resource.path}`,
                    headers: {
                        Accept: resource.contentType,
                        'Content-Type': resource.contentType,
                    },
                };
                try {
                    const response = await staticAxios(config);
                    results[resource.key] = response.data;
                } catch (err) {
                    /* istanbul ignore next */
                    // eslint-disable-next-line no-console
                    console.warn(
                        `Warning: failed loading ${resource.path},  using default data.`,
                        err,
                    );
                    results[resource.key] = resource.defaultData;
                }
            }
            return results;
        },
    },
};
